import { create } from 'zustand';

export type ChatDraft = {
  text: string;
  files: File[];
  context?: { model: string; groups: string[]; skills: string[]; projectId: string | null };
};
export const EMPTY_DRAFT: ChatDraft = { text: '', files: [] };
/** Session memory only: prompts and files must never enter localStorage or URLs. */
export const useDrafts = create<{
  entries: Record<string, ChatDraft>;
  ownerId: string | null;
  bindOwner: (id: string) => void;
  update: (key: string, patch: Partial<ChatDraft>) => void;
  move: (from: string, to: string) => void;
  clear: () => void;
}>((set) => ({
  entries: {},
  ownerId: null,
  bindOwner: (id) =>
    set((state) => ({ ownerId: id, entries: state.ownerId === id ? state.entries : {} })),
  update: (key, patch) =>
    set((state) => ({
      entries: { ...state.entries, [key]: { ...(state.entries[key] ?? EMPTY_DRAFT), ...patch } },
    })),
  move: (from, to) =>
    set((state) => {
      const entries = { ...state.entries, [to]: state.entries[from] ?? EMPTY_DRAFT };
      delete entries[from];
      return { entries };
    }),
  clear: () => set({ entries: {}, ownerId: null }),
}));
